export default {
  methods: {
    /**
     * /002のページでのみファーストメッセージの文言を切り替える
     * クエリパラメータ（current-job）の値で動的に文言を切り替え
     */
    FirstMessageMixin: function () {
      const locationPath = window.location.pathname
      const firstMessages = {
        default: '20代に特化した無料の就職・転職支援サービス「第二新卒エージェント」へようこそ！',
        fullTime: '正社員を目指す20代に特化した無料の就職・転職支援サービス「第二新卒エージェント」へようこそ！',
        freeter: '20代のフリーターに特化した無料の就職・転職支援サービス「第二新卒エージェント」へようこそ！',
        neet: 'ニートからの就職・転職に強い、20代特化型の無料サポート「第二新卒エージェント」へようこそ！',
        dropout: '中退からの就職に強い、20代特化型の無料就職サポート「第二新卒エージェント」へようこそ！',
        inexperienced: '未経験の業界や職種を目指す20代に特化した無料の就職・転職支援サービス「第二新卒エージェント」へようこそ！',
        graduated: '既卒からの就職に強い、20代特化型の無料就職サポート「第二新卒エージェント」へようこそ！'
      }

      if (locationPath === '/lp/chat/002/') {
        // クエリパラメータ取得
        const searchParams = new URLSearchParams(window.location.search)
        // クエリパラメータにcurrent-jobが含まれているか
        if (searchParams.has('current-job')) {
          const currentJobParam = searchParams.get('current-job')
          // クエリパラメータ値に応じてファーストメッセージ返却
          switch (currentJobParam) {
            case 'full-time':
              return firstMessages.fullTime
            case 'freeter':
              return firstMessages.freeter
            case 'neet':
              return firstMessages.neet
            case 'dropout':
              return firstMessages.dropout
            case 'inexperienced':
              return firstMessages.inexperienced
            case 'graduated':
              return firstMessages.graduated
            default:
              return firstMessages.default
          }
        }
      }
      return firstMessages.default
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/FirstMessageMixin.js